import { IcoChevronDown16 } from '@onefootprint/icons';
import * as RadixDropdown from '@radix-ui/react-dropdown-menu';
import { cx } from 'class-variance-authority';
import { forwardRef } from 'react';
import type { TriggerProps } from '../dropdown.types';

const Trigger = forwardRef<HTMLButtonElement, TriggerProps>(
  ({ children, width, height, maxWidth, minWidth, hasChevron, ariaLabel, inline, ...props }, ref) => {
    return (
      <RadixDropdown.Trigger {...props} ref={ref} asChild>
        <div
          aria-label={ariaLabel}
          className={cx(
            inline ? 'inline-flex' : 'flex',
            'cursor-pointer group items-center gap-2',
            'focus:outline-none',
            'focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-primary',
            'data-[disabled]:cursor-auto data-[disabled]:select-none data-[disabled]:hover:bg-transparent',
          )}
          style={{
            width: width || 'fit-content',
            maxWidth,
            minWidth,
          }}
        >
          {children}
          {hasChevron && (
            <div className="flex items-center w-full justify-center group-data-[state=open]:rotate-180 origin-center group-data-[state=closed]:rotate-0 transition-transform duration-200 group-data-[disabled]:opacity-40 group-data-[disabled]:cursor-auto">
              <IcoChevronDown16 />
            </div>
          )}
        </div>
      </RadixDropdown.Trigger>
    );
  },
);

export default Trigger;
